module.exports = __webpack_public_path__ + "images/stickers/taco-celebrate.ba8d89317872277d730b.png";